export default __webpack_public_path__ + "static/media/aws.9b1bc77b.svg";